import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Card,
  Avatar,
  List,
  Collapse,
  Typography,
  Button,
  message,
  Row,
  Col,
} from 'antd';
import {
  CloseOutlined,
  UsergroupAddOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { StoreContext } from '../store/index';
import { addRequest } from '../requests/api';
import { getDateFromTimestamp, copyText } from '../utils';
import PlayerProfileDrawer from '../profile/playerProfileDrawer';

const { Paragraph, Title } = Typography;

function PlayersList({
  shift,
  header,
  dataSource,
  share,
  startOpen = true,
  addPlayerModalAction = null,
  handleRemoveFriend = null,
  selectPlayer = null,
  handleAddPlayerToTeam = null,
  handleRemovePlayerFromTeam = null,
}) {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser, setUpdateUser],
    isUserLoading: [isUserLoading, setIsUserLoading],
    allRequests: [allRequests],
  } = store;

  const { Panel } = Collapse;

  const [showPlayerProfile, setShowPlayerProfile] = useState(false);
  const [playerProfileId, setPlayerProfileId] = useState('false');
  const [open, setOpen] = useState(startOpen && ['playersPanel']);
  const [loading, setLoading] = useState(false);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [filterValue, setFilterValue] = useState('');

  const handleAddPlayerModalAction = value => {
    addPlayerModalAction(value);
  };
  const handleFilter = value => {
    setFilteredDataSource(
      value !== ''
        ? dataSource.filter(data =>
            data.nickname.toUpperCase().includes(value.toUpperCase()),
          )
        : dataSource,
    );
  };

  useEffect(() => {
    handleFilter(filterValue);
  }, [filterValue, dataSource]);

  const handleSelectPlayer = item => {
    selectPlayer(item);
    setOpen('');
  };
  return (
    <>
      <Collapse
        key="friends"
        className="width100"
        style={{ marginTop: '2px' }}
        activeKey={open}
        onChange={() => setOpen(open === 'playersPanel' ? '' : 'playersPanel')}
        items={[
          {
            key: 'playersPanel',
            label: header,
            children: (
              <div
                style={{
                  overflow: 'auto',
                  maxHeight: selectPlayer ? '200px' : '300px',
                  scrollbarWidth: 'thin',
                }}>
                <Input
                  style={{ marginBottom: '6px' }}
                  placeholder="Filtrar"
                  value={filterValue}
                  onChange={e => setFilterValue(e.target.value)}
                />
                <List
                  size="small"
                  itemLayout="vertical"
                  loading={loading || isUserLoading}
                  open
                  dataSource={filteredDataSource}
                  renderItem={item => (
                    <List.Item
                      style={{ padding: '0px', marginTop: '8px' }}
                      key={item.userId}>
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            onClick={() => {
                              setPlayerProfileId(item.uid);
                              setShowPlayerProfile(true);
                            }}
                            src={item.photoURL}
                          />
                        }
                        title={
                          <Row justify="space-between">
                            <Col
                              xs={10}
                              onClick={() => {
                                setPlayerProfileId(item.uid);
                                setShowPlayerProfile(true);
                              }}>
                              {item.nickname}
                            </Col>
                            <Col xs={14}>
                              {handleAddPlayerToTeam && (
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={item.id}
                                      type="primary"
                                      loading={loading}
                                      icon={<UserAddOutlined />}
                                      onClick={() =>
                                        handleAddPlayerToTeam(item)
                                      }
                                    />
                                  </Col>
                                </Row>
                              )}
                              {handleRemovePlayerFromTeam && (
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={item.id}
                                      loading={loading}
                                      danger
                                      icon={<CloseOutlined />}
                                      onClick={() =>
                                        handleRemovePlayerFromTeam(item)
                                      }
                                    />
                                  </Col>
                                </Row>
                              )}
                              {addPlayerModalAction && (
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      key={item.id}
                                      type="primary"
                                      loading={loading}
                                      onClick={() =>
                                        handleAddPlayerModalAction({
                                          ...item,
                                          isLocal: true,
                                        })
                                      }>
                                      {shift?.localTeam?.name}
                                    </Button>
                                  </Col>
                                  <Col offset={2}>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={item.id}
                                      type="primary"
                                      loading={loading}
                                      onClick={() =>
                                        handleAddPlayerModalAction({
                                          ...item,
                                          isLocal: false,
                                        })
                                      }>
                                      {shift?.visitTeam?.name}
                                    </Button>
                                  </Col>
                                </Row>
                              )}
                              {share && (
                                <Row>
                                  {!allRequests.find(
                                    r =>
                                      r.shiftId === shift.id &&
                                      r.to === item.email,
                                  ) &&
                                    user.email !== item.email && (
                                      <Row justify="end">
                                        <Col>
                                          <Button
                                            style={{ marginRight: '8px' }}
                                            key={item.id}
                                            type="primary"
                                            loading={loading}
                                            icon={<UsergroupAddOutlined />}
                                            onClick={() => {
                                              addRequest(
                                                {
                                                  shiftId: shift.id,
                                                  photoURL: user.photoURL,
                                                  from: user.nickname,
                                                  to: item.email,
                                                  startDate:
                                                    getDateFromTimestamp(
                                                      shift.startDate,
                                                    ),
                                                  placeName: shift.placeName,
                                                  messageToken:
                                                    item.messageToken,
                                                  title: `Nuevo Partido en ${shift.placeName}`,
                                                  url: `https://www.gamebooking.top/shifts?${shift.id}`,
                                                  isNew: true,
                                                },
                                                setLoading,
                                              );
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    )}
                                </Row>
                              )}
                              {handleRemoveFriend && (
                                <Row justify="end">
                                  <Col>
                                    <Button
                                      style={{ marginRight: '8px' }}
                                      key={item.id}
                                      loading={loading}
                                      danger
                                      icon={<CloseOutlined />}
                                      onClick={() =>
                                        handleRemoveFriend(
                                          item.email,
                                          setLoading,
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              )}
                              {selectPlayer && (
                                <Row>
                                  <Col offset={16}>
                                    <Button
                                      key={item.id}
                                      type="primary"
                                      loading={loading}
                                      icon={<UserAddOutlined />}
                                      onClick={() => handleSelectPlayer(item)}
                                    />
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        }
                        description=""
                      />
                    </List.Item>
                  )}
                />
              </div>
            ),
          },
        ]}
      />
      {showPlayerProfile && playerProfileId && (
        <PlayerProfileDrawer
          playerId={playerProfileId}
          visible={showPlayerProfile}
          onClose={() => setShowPlayerProfile(false)}
        />
      )}
    </>
  );
}

export default PlayersList;
